module.exports = function() {
  return new Worker(__webpack_public_path__ + "477c1b0f49f1a2e74deb.worker.js");
};